import './App.css'
import store from './redux/Store'
import { Provider } from 'react-redux'
import Navigation from './Navigator'
import { BrowserRouter as Router } from 'react-router-dom'

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Navigation />
      </Router>
    </Provider>
  )
}

export default App
